<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <!-- <v-layout row wrap v-if="agent">
      <v-flex md6 class="pa-4">
        <div>
          <strong>Name</strong><br />
          <p>{{ agent.name }}</p>
        </div>
        <div>
          <strong>Email</strong><br />
          <p>{{ agent.email }}</p>
        </div>
        <div>
          <strong>Notes</strong><br />
          <p>{{ agent.notes }}</p>
        </div>
      </v-flex>
      <v-flex md6 class="pa-4">
        <div>
          <strong>Mobile</strong><br />
          <p>{{ agent.mobile }}</p>
        </div>
        <div>
          <strong>Address</strong><br />
          <p>{{ agent.address }}</p>
        </div>
      </v-flex>
    </v-layout> -->
    <div v-if="agent" class="pa-4">
      <v-layout row wrap>
        <v-flex md3>
          <strong>Name</strong><br />
          <p>{{ agent.name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Father's Name</strong><br />
          <p>{{ agent.mother_name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Mother's Name</strong><br />
          <p>{{ agent.father_name }}</p>
        </v-flex>
      </v-layout>

      <u>Present Address:</u>
      <v-layout row wrap>
        <v-flex md3>
          <strong>District</strong><br />
          <p>{{ valueToText(districtTV(), agent.present_district) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.S</strong><br />
          <p>{{ valueToText(upazilaTV(), agent.present_upazila) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.O</strong><br />
          <p>{{ valueToText(unionTV(), agent.present_union) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Vill</strong><br />
          <p>{{ agent.present_village }}</p>
        </v-flex>
      </v-layout>

      <u>Permanent Address:</u>
      <v-layout row wrap>
        <v-flex md3>
          <strong>District</strong><br />
          <p>{{ valueToText(districtTV(), agent.permanent_district) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.S</strong><br />
          <p>{{ valueToText(upazilaTV(), agent.permanent_upazila) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.O</strong><br />
          <p>{{ valueToText(unionTV(), agent.permanent_union) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Vill</strong><br />
          <p>{{ agent.permanent_village }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Date of Birth</strong><br />
          <p>{{ agent.dob }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Age</strong><br />
          <p>{{ agent.age }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>NID Number</strong><br />
          <p>{{ agent.nid_number }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Nationality</strong><br />
          <p>{{ agent.nationality }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Gender</strong><br />
          <p>{{ agent.gender }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Religion</strong><br />
          <p>{{ agent.religion }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Mobile Number</strong><br />
          <p>{{ agent.mobile }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Emergency Contact</strong><br />
          <p>{{ agent.emergency_contact }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Relation</strong><br />
          <p>{{ agent.emergency_relation }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Company Name</strong><br />
          <p>{{ agent.company_name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Staff Mobile No.</strong><br />
          <p>{{ agent.company_staff_contact }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Email</strong><br />
          <p>{{ agent.email }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md12>
          <strong>Notes</strong><br />
          <p>{{ agent.notes }}</p>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import {
  valueToText,
  getTV,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";
export default {
  props: ["agent", "title"],
  // data() {
  //   return {
  //     // relatedFiles: [],
  //   };
  // },

  // computed: {},

  methods: {
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
    valueToText: valueToText,
  },

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
